import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import AddEditEmailTemplate from './AddEditEmailTemplate';
import { useSelector, useDispatch } from 'react-redux';
import CustomTable from 'components/CustomTable';
import { GET_EMAIL_TEMPLATE_LIST } from 'store/key';
import { getTimeWithTimeZone } from 'utility/general';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    title: {
        marginRight: theme.spacing(4),
        fontWeight: 'bold',
    },
    tableContanier: {
        marginTop: theme.spacing(2),
    },
}));

const EmailTemplate = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const emailTemplateList = useSelector((state) => state.emailTemplate.emailTemplateList);
    const isLoading = useSelector((state) => state.emailTemplate.isLoading);

    const columns = [
        { field: 'title', headerName: 'Title', width: 400 },
        { field: 'to', headerName: 'To Recipients', width: 280 },
        { field: 'cc', headerName: 'CC Recipients', width: 280 },
        {
            field: 'createDtm', headerName: 'Created Date', width: 180,
            valueGetter: (params) => {
                return params.value ? getTimeWithTimeZone(params.value).format('YYYY-MM-DD') : '-';
            },
        },
        {
            field: 'updateDtm', headerName: 'Modified Date', width: 180,
            valueGetter: (params) => {
                return params.value ? getTimeWithTimeZone(params.value).format('YYYY-MM-DD') : '-';
            },
        },
    ];

    const getList = () => {
        dispatch({
            type: GET_EMAIL_TEMPLATE_LIST,
            payload: null,
        });
    };

    useEffect(() => {
        getList();
        // eslint-disable-next-line
    }, []);

    const rows = emailTemplateList;
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleEdit = (row) => {
        setSelectedRow(row);
        setOpenPopup(true);
    };
    return (
        <Grid container wrap="nowrap" direction="column" className={classes.root}>
            {openPopup ? <AddEditEmailTemplate
                rowData={selectedRow}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                getList={getList}
            /> : null}
            <Grid container wrap="nowrap" alignItems="center">
                <Typography className={classes.title}>Email Templates:</Typography>
            </Grid>
            <Grid className={classes.tableContanier}>
                <CustomTable
                    isEditAllow={true}
                    onEdit={handleEdit}
                    columns={columns}
                    rows={rows}
                    allowResize
                    fullWidthTable={false}
                    loading={isLoading}
                />
            </Grid>
        </Grid>
    );
};

export default EmailTemplate;
